{
  "id": "campaign-061",
  "name": "Merry Hole",
  "seed": "campaign:61",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "._.x...T....",
    "._.sssooo...",
    "._.*..oFos..",
    "._.*..ooos..",
    "._.*........",
    "._.....q..h.",
    "._..........",
    "._...T......",
    "._..........",
    "._*.q....#*.",
    "T_........*.",
    "._...W....*.",
    "._.........x",
    "......b.....",
    "...b.......S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 5,
      "y": 9
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 2
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 4
    },
    {
      "kind": "repair",
      "x": 3,
      "y": 10
    }
  ],
  "generatorVersion": 3,
  "level": 61,
  "biome": "golf",
  "par": {
    "reel": 5070,
    "push": 4810,
    "selfPropelled": 4248,
    "tractor": 4040,
    "zeroTurn": 3009,
    "fairway": 1958
  },
  "routeTries": {
    "par": {
      "reel": 1,
      "push": 18,
      "selfPropelled": 24,
      "tractor": 2,
      "zeroTurn": 7,
      "fairway": 4
    }
  }
}
